<template>
    <div class="border p-4 rounded-sm mb-3">
        <b-row>
            <b-col sm="12">
                <b-button class="mb-2" variant="primary" @click="openReferenceModal(null)">{{ $t('reference_add_btn') }}</b-button>
            </b-col>
            <b-col sm="12">
                <b-table :empty-filtered-text="$t('no_result')"
                         :empty-text="$t('no_result')"
                         bordered
                         responsive
                         :items="references"
                         :fields="referenceFields"
                         show-empty
                         class="mb-4 table-dropdown no-scrollbar border rounded">
                    <template #cell(buttons)="row">
                        <b-dropdown variant="link btn-sm" boundary="window" no-caret>
                            <template #button-content>
                                <i class="ri-more-fill"></i>
                            </template>
                            <div id="dropdownListHead">
                                <b-dropdown-item @click="deleteReferance(row.index)">
                                    <i class="ri-delete-bin-2-line align-middle top-minus-1 mr-3 text-muted"></i> {{$t('delete')}}
                                </b-dropdown-item>
                            </div>
                        </b-dropdown>
                    </template>
                </b-table>
                <div class="d-flex justify-content-center mt-3">
                    <b-button
                        @click="save"
                        class="ml-2 rounded flex-grow-0"
                        variant="primary"
                    >{{ $t('save_and_go') }}</b-button>
                </div>
            </b-col>
        </b-row>
        <CommonModal ref="referenceModal" size="lg">
            <template v-slot:CommonModalTitle>
                <div>{{ referenceModalTitle }}</div>
            </template>
            <template v-slot:CommonModalContent>
                <ValidationObserver ref="referenceFormValidate">
                    <b-row>
                        <b-col cols="6">
                            <b-row>
                                <b-col cols="12">
                                    <b-form-group :label="$t('name')">
                                        <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                                            <b-form-input v-model="referenceFormData.name"
                                                          :state="errors[0] ? false : null" />
                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-group :label="$t('surname')">
                                        <ValidationProvider name="surname" rules="required" v-slot="{ errors }">
                                            <b-form-input v-model="referenceFormData.surname"
                                                          :state="errors[0] ? false : null" />
                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-group :label="$t('gsm_no')">
                                        <ValidationProvider name="phone" rules="required" v-slot="{ errors }">
                                            <b-form-input v-model="referenceFormData.phone"
                                                          v-mask="'5## ### ## ##'"
                                                          :state="errors[0] ? false : null" />
                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-group :label="$t('email')">
                                        <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                                            <b-form-input v-model="referenceFormData.email"
                                                          :state="errors[0] ? false : null" />
                                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                        </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="12" lg="12" class="mt-5">
                                    <ValidationProvider name="letter" rules="required" v-slot="{errors}">
                                        <b-input-group class="mb-0 mt-1">
                                            <b-form-file v-model="referenceFormData.letter"
                                                         :placeholder="$t('letter_of_reference')"
                                                         :state="errors[0] ? false : null"
                                                         :accept="'.pdf,.doc,.docx'"
                                                         ref="fileInput3"
                                            />
                                            <b-input-group-append>
                                                <b-button variant="outline-secondary" @click="$refs.fileInput3.$el.childNodes[0].click()">{{ $t('browse') }}</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <b-form-invalid-feedback v-if="errors[0]">
                                            <span v-html="errors[0]"></span>
                                        </b-form-invalid-feedback>
                                    </ValidationProvider>
                                    <b-alert class="mb-4 mt-2" variant="info" show>
                                        {{ $t('bisep_file_upload_info') }}
                                    </b-alert>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="6">
                            <b-alert show variant="info">{{ $t('reference_letter_warning') }}</b-alert>
                        </b-col>
                        <b-col cols="12" class="d-flex justify-content-center mb-3 mt-4">
                            <b-button variant="primary" @click="addToReferences">{{ $t('save') }}</b-button>
                        </b-col>
                    </b-row>
                </ValidationObserver>
            </template>
        </CommonModal>

    </div>
</template>

<script>


export default {
    name: "ReferenceTab",
    components: {

    },
    data() {
        return {
            referenceFields: [
                { key: "buttons", label: "" },
                { key: "name", label: this.$t("name") },
                { key: "surname", label: this.$t("surname") },
                { key: "phone", label: this.$t("gsm_no") },
                { key: "email", label: this.$t("email") },
            ],
            referenceFormData: {},
            evaluateFormData: {},
            references:[],
            referenceModalTitle: null,
            referenceStatusOptions: [
                { value: "approved", text: this.$t("approved") },
                { value: "rejected", text: this.$t("rejected") },
            ],
        };
    },
    methods: {
        openReferenceModal(data) {
            if (data != null) {
                this.referenceModalTitle = this.$t("edit");
                this.referenceFormData = { ...data };
            } else {
                this.referenceModalTitle = this.$t("reference");
                this.referenceFormData = {};
            }
            this.$refs.referenceModal.$refs.commonModal.show();
        },
        deleteReferance(key) {
            this.$swal
                .fire({
                    text: this.$t("are_you_sure_to_delete"),
                    showCancelButton: true,
                    confirmButtonText: this.$t("yes"),
                    cancelButtonText: this.$t("no"),
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.references.splice(key,1)
                        this.$toast.success(this.$t('proccess_success'))
                    }
                });
        },
        addToReferences(){
            const references =this.references
            this.references.push({
                ...references,
                ...this.referenceFormData
            })
            this.$toast.success(this.$t('proccess_success'))
            this.$refs.referenceModal.$refs.commonModal.hide()
        },
        save(){
            this.$emit('nextTab',{
                currentTab:2,
                formData:{
                    references:this.references
                }
            })

        }
    },
};
</script>
<style>
.file-upload-area {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border: 2px dashed #dee2e6;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    min-height: 60px;
}

.file-upload-area:hover {
    border-color: #0d6efd;
    background-color: #f8f9fa;
}

.file-upload-area.is-invalid {
    border-color: #dc3545;
}

.file-upload-area.has-file {
    border-color: #198754;
    border-style: solid;
    background-color: #f0fff4;
}

.upload-icon {
    font-size: 24px;
    color: #6c757d;
    min-width: 32px;
}

.file-upload-area:hover .upload-icon {
    color: #0d6efd;
}

.file-upload-area.has-file .upload-icon {
    color: #198754;
}

.upload-text {
    flex: 1;
    color: #6c757d;
    font-size: 14px;
}

.placeholder-text {
    color: #6c757d;
}

.file-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.file-name {
    color: #198754;
    font-weight: 600;
    font-size: 14px;
}

.file-size {
    color: #6c757d;
    font-size: 12px;
}
</style>
